import * as React from "react";
const Approval = () => {
  return (
    <svg
      width="231"
      height="180"
      viewBox="0 0 231 180"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 0H231V180H0V0Z" fill="url(#paint0_radial_2437_10563)" />
      <path
        d="M231 180V179H0V180V181H231V180Z"
        fill="url(#paint1_linear_2437_10563)"
        mask="url(#path-1-inside-1_2437_10563)"
      />
      <g clip-path="url(#clip0_2437_10563)">
        <path
          d="M103.646 17.102C103.646 17.102 115.256 0.126387 129.776 8.59121C147.953 19.1923 126.006 44.426 139.438 51.7308C152.87 59.0356 166.772 59.6099 170.646 79.8129C175.7 106.23 128.034 143.362 87.7153 119.851C47.3962 96.3405 61.7452 52.3396 80.6784 43.5761C103.451 33.0439 103.646 17.102 103.646 17.102Z"
          fill="#1B1211"
        />
        <path
          d="M120.196 62.1594V80.2721C120.293 81.7645 120.083 83.261 119.579 84.6689C119.076 86.0768 118.29 87.3662 117.269 88.4575C116.249 89.5487 115.016 90.4186 113.646 91.0132C112.277 91.6079 110.801 91.9147 109.308 91.9147C107.816 91.9147 106.339 91.6079 104.97 91.0132C103.601 90.4186 102.368 89.5487 101.347 88.4575C100.327 87.3662 99.5405 86.0768 99.0371 84.6689C98.5336 83.261 98.3238 81.7645 98.4205 80.2721V62.1594H120.196Z"
          fill="#E88C7B"
        />
        <path
          d="M74.5474 49.7438C74.8702 51.3309 75.6555 52.7865 76.8038 53.9264C77.9522 55.0662 79.4121 55.8392 80.9988 56.1476C82.5855 56.4559 84.2278 56.2858 85.7181 55.6586C87.2083 55.0315 88.4795 53.9756 89.3709 52.6244C90.2623 51.2732 90.7338 49.6875 90.7258 48.0677C90.7178 46.4479 90.2307 44.8669 89.3261 43.5246C88.4214 42.1823 87.1399 41.139 85.6436 40.5267C84.1472 39.9143 82.5032 39.7605 80.9196 40.0845C78.7981 40.5217 76.9362 41.7839 75.7417 43.5945C74.5473 45.4051 74.1178 47.6164 74.5474 49.7438Z"
          fill="#E88C7B"
        />
        <path
          d="M86.8102 36.0302V49.8128C86.8102 49.8128 81.3434 44.9429 81.4924 35.3525L86.8102 36.0302Z"
          fill="#1B1211"
        />
        <path
          d="M76.7932 46.6426L83.2686 51.03"
          stroke="#1B1211"
          stroke-width="0.75"
          stroke-miterlimit="10"
        />
        <path
          d="M121.869 48.1013C122.194 49.6877 122.982 51.1418 124.132 52.2797C125.282 53.4176 126.743 54.1882 128.33 54.4941C129.917 54.8 131.558 54.6275 133.048 53.9983C134.537 53.3691 135.806 52.3115 136.696 50.9592C137.585 49.607 138.054 48.0208 138.044 46.4013C138.034 44.7817 137.545 43.2015 136.639 41.8605C135.733 40.5195 134.45 39.4779 132.953 38.8673C131.456 38.2568 129.813 38.1048 128.23 38.4305C127.178 38.6468 126.18 39.0686 125.291 39.6717C124.402 40.2748 123.641 41.0474 123.05 41.9455C122.46 42.8435 122.051 43.8494 121.848 44.9056C121.646 45.9619 121.653 47.0478 121.869 48.1013Z"
          fill="#E88C7B"
        />
        <path
          d="M129.868 46.459C129.868 46.459 134.544 41.3364 132.906 29.2307H126.35L129.868 46.459Z"
          fill="#1B1211"
        />
        <path
          d="M128.527 50.0769L134.865 43.9207"
          stroke="#1B1211"
          stroke-width="0.75"
          stroke-miterlimit="10"
        />
        <path
          d="M108.345 14.4487C102.633 14.4487 97.1559 16.7225 93.1174 20.7698C89.0788 24.817 86.8099 30.3063 86.8099 36.03V51.7422C86.8104 53.3753 87.2251 54.9815 88.015 56.4099C88.8049 57.8384 89.944 59.0422 91.3255 59.9084L103.245 67.3855C104.774 68.3429 106.541 68.8505 108.345 68.8505C110.148 68.8505 111.915 68.3429 113.445 67.3855L125.364 59.9084C126.744 59.0416 127.882 57.8374 128.67 56.4089C129.458 54.9803 129.87 53.3745 129.868 51.7422V36.03C129.87 33.1965 129.314 30.3904 128.233 27.7721C127.152 25.1538 125.567 22.7746 123.568 20.7704C121.569 18.7663 119.196 17.1764 116.584 16.0917C113.972 15.007 111.172 14.4487 108.345 14.4487Z"
          fill="#E88C7B"
        />
        <path
          d="M98.351 64.5142L103.21 67.5578C104.738 68.5204 106.506 69.0312 108.31 69.0312C110.115 69.0312 111.883 68.5204 113.41 67.5578"
          stroke="#1B1211"
          stroke-width="0.75"
          stroke-miterlimit="10"
        />
        <path
          d="M106.534 14.4487L111.944 51.7422H105.159"
          stroke="#1B1211"
          stroke-width="0.75"
          stroke-miterlimit="10"
        />
        <path
          d="M128.917 46.9987C128.917 48.0913 128.594 49.1594 127.988 50.0679C127.382 50.9764 126.521 51.6845 125.514 52.1027C124.507 52.5208 123.398 52.6302 122.329 52.417C121.26 52.2039 120.277 51.6777 119.506 50.9051C118.736 50.1325 118.21 49.1481 117.998 48.0764C117.785 47.0048 117.894 45.894 118.311 44.8845C118.729 43.875 119.435 43.0122 120.342 42.4052C121.248 41.7981 122.314 41.4741 123.405 41.4741C124.129 41.4726 124.846 41.6145 125.516 41.8916C126.185 42.1687 126.794 42.5755 127.306 43.0888C127.818 43.6021 128.224 44.2118 128.501 44.8827C128.777 45.5537 128.919 46.2727 128.917 46.9987Z"
          fill="#E6715C"
        />
        <path
          d="M99.589 46.9987C99.589 48.0913 99.2657 49.1594 98.66 50.0679C98.0542 50.9764 97.1933 51.6845 96.186 52.1027C95.1787 52.5208 94.0702 52.6302 93.0009 52.417C91.9315 52.2039 90.9493 51.6777 90.1784 50.9051C89.4074 50.1325 88.8824 49.1481 88.6697 48.0764C88.457 47.0048 88.5661 45.894 88.9833 44.8845C89.4006 43.875 90.1072 43.0122 91.0137 42.4052C91.9203 41.7981 92.9861 41.4741 94.0764 41.4741C94.8008 41.4726 95.5182 41.6145 96.1877 41.8916C96.8572 42.1687 97.4656 42.5755 97.9778 43.0888C98.49 43.6021 98.896 44.2118 99.1725 44.8827C99.449 45.5537 99.5906 46.2727 99.589 46.9987Z"
          fill="#E6715C"
        />
        <path
          d="M118.293 45.1841C119.344 45.1841 120.195 43.6362 120.195 41.7269C120.195 39.8176 119.344 38.2698 118.293 38.2698C117.242 38.2698 116.39 39.8176 116.39 41.7269C116.39 43.6362 117.242 45.1841 118.293 45.1841Z"
          fill="#1B1211"
        />
        <path
          d="M100.288 41.7269C100.288 43.6335 99.4401 45.1726 98.3857 45.1726C97.3313 45.1726 96.4832 43.622 96.4832 41.7269C96.4832 39.8318 97.3428 38.2812 98.3857 38.2812C99.4286 38.2812 100.288 39.8203 100.288 41.7269Z"
          fill="#1B1211"
        />
        <path
          d="M133.513 11.52C118.993 3.05517 103.635 17.102 103.635 17.102C103.635 17.102 103.452 33.0438 80.7134 43.5761C75.9113 45.7928 69.4704 53.7063 66.4562 58.5072C66.4562 58.5072 73.1149 39.269 75.2123 26.8302C77.3096 14.3914 88.3234 16.3439 88.3234 16.3439C88.3234 16.3439 95.0165 -0.0459241 113.537 0.0344745C126.339 0.0574455 133.513 11.52 133.513 11.52Z"
          fill="#322A28"
        />
        <path
          d="M116.884 27.5079C118.603 24.8777 120.322 24.5561 121.388 28.0707L116.884 27.5079Z"
          fill="#1B1211"
        />
        <path
          d="M93.297 28.5071C93.5491 25.36 94.8671 24.2804 97.5146 26.8302L93.297 28.5071Z"
          fill="#1B1211"
        />
        <path
          d="M101.927 54.4414L115.176 55.3832C115.176 55.3832 113.915 60.4713 109.858 61.126C108.891 61.2563 107.908 61.1827 106.971 60.9099C106.034 60.6371 105.164 60.171 104.417 59.5417C103.671 58.9123 103.063 58.1335 102.635 57.2552C102.206 56.3769 101.965 55.4185 101.927 54.4414Z"
          fill="white"
        />
        <path
          d="M109.824 57.6572L102.947 57.4275"
          stroke="#1B1211"
          stroke-width="0.75"
          stroke-miterlimit="10"
        />
        <path
          d="M177.431 149.656C176.401 150.538 175.208 151.208 173.919 151.627C172.631 152.047 171.272 152.208 169.922 152.101C168.571 151.994 167.255 151.622 166.048 151.006C164.841 150.389 163.767 149.54 162.887 148.508L129.502 109.606C128.622 108.574 127.954 107.378 127.535 106.087C127.117 104.796 126.956 103.434 127.062 102.081C127.169 100.727 127.54 99.4082 128.156 98.1986C128.771 96.989 129.618 95.9127 130.648 95.0312C131.678 94.1495 132.872 93.4797 134.16 93.0602C135.448 92.6408 136.807 92.4797 138.157 92.5864C139.508 92.693 140.824 93.0653 142.031 93.6818C143.238 94.2984 144.312 95.1472 145.192 96.1797L179.895 137.39C179.895 137.39 181.729 145.947 177.431 149.656Z"
          fill="#E88C7B"
        />
        <path
          d="M161.581 104.449L143.988 113.58L129.662 130.177L147.896 120.081L161.581 104.449Z"
          fill="#B45458"
        />
        <path
          d="M144.79 89.8512L162.658 112.558L138.189 132.348L122.144 105.414C121.136 103.729 120.5 101.847 120.277 99.8948C120.055 97.9427 120.251 95.9655 120.854 94.0958C121.456 92.2261 122.45 90.507 123.77 89.0539C125.089 87.6008 126.704 86.4472 128.505 85.6705C131.298 84.4642 134.412 84.2203 137.359 84.9767C140.306 85.7332 142.919 87.4475 144.79 89.8512Z"
          fill="#F27376"
        />
        <path
          d="M161.581 104.449L147.896 120.081L129.662 130.177L139.106 138.114L154.269 127.822L167.724 112.581L161.581 104.449Z"
          fill="white"
        />
        <path
          d="M195.768 106.459L182.634 145.441C182.102 147.012 181.231 148.446 180.082 149.64C178.932 150.834 177.534 151.759 175.987 152.349C174.439 152.938 172.781 153.177 171.13 153.049C169.48 152.921 167.878 152.429 166.439 151.609C164.008 150.239 162.176 148.008 161.304 145.353C160.433 142.698 160.584 139.812 161.729 137.263C168.514 122.47 180.066 114.522 188.524 98.3848L195.768 106.459Z"
          fill="#E88C7B"
        />
        <path
          d="M185.775 103.933L186.439 96.5473C188.261 91.5971 195.012 84.7517 195.012 84.7517L197.682 88.048C211.791 99.4532 194.955 108.412 194.955 108.412L185.775 103.933Z"
          fill="#E88C7B"
        />
        <path
          d="M191.023 89.139L201.029 99.5794L202.587 99.9354C205.269 96.7999 207.825 91.7807 202.392 87.1176C201.248 86.1472 199.994 85.3145 198.656 84.6367C194.462 81.4552 191.023 89.139 191.023 89.139Z"
          fill="#E88C7B"
        />
        <path
          d="M196.605 102.485C201.12 95.4448 193.808 90.5865 193.808 90.5865L194.622 84.1086"
          stroke="#1B1211"
          stroke-width="0.75"
          stroke-miterlimit="10"
        />
        <path
          d="M197.052 94.1127C198.338 93.3019 199.44 92.2298 200.286 90.9656C201.133 89.7014 201.706 88.2733 201.968 86.7734"
          stroke="#1B1211"
          stroke-width="0.75"
          stroke-miterlimit="10"
        />
        <path
          d="M195.081 91.93C196.901 89.8623 198.135 87.3441 198.656 84.6367"
          stroke="#1B1211"
          stroke-width="0.75"
          stroke-miterlimit="10"
        />
        <path
          d="M202.644 99.9352L198.484 97.4198C198.484 97.4198 203.894 95.1227 204.868 90.0347"
          stroke="#1B1211"
          stroke-width="0.75"
          stroke-miterlimit="10"
        />
        <path
          d="M186.439 96.5475C186.439 96.5475 187.769 89.7596 180.159 85.8086L181.053 84.9472C181.521 84.4858 182.123 84.1867 182.773 84.0937C183.423 84.0007 184.085 84.1186 184.663 84.4303C187.292 85.7109 189.632 87.5166 191.54 89.7366L186.439 96.5475Z"
          fill="#E88C7B"
        />
        <path
          d="M17.633 133.071C15.9344 130.928 15.1531 128.198 15.4603 125.479C15.7675 122.759 17.1382 120.273 19.2719 118.565L59.3847 86.5663C61.5237 84.8604 64.2508 84.0752 66.9671 84.3832C69.6833 84.6911 72.1666 86.0671 73.8712 88.2087C75.5733 90.3523 76.3568 93.0853 76.0495 95.8074C75.7422 98.5295 74.3693 101.018 72.2323 102.726L32.1768 134.725C31.1153 135.578 29.896 136.212 28.589 136.591C27.282 136.969 25.9132 137.085 24.5614 136.931C23.2096 136.778 21.9015 136.357 20.7124 135.695C19.5233 135.032 18.4767 134.141 17.633 133.071Z"
          fill="#E88C7B"
        />
        <path
          d="M127.92 163.209H86.661L63.5904 90.1612C62.9081 87.9497 62.8453 85.5929 63.4088 83.348C63.9722 81.1031 65.1402 79.0565 66.7852 77.4316C68.4303 75.8067 70.4891 74.666 72.7371 74.1339C74.9851 73.6019 77.3357 73.6989 79.5324 74.4146L111.989 85.2569L133.822 84.6022C135.645 84.5477 137.455 84.9225 139.107 85.6965C140.759 86.4705 142.206 87.622 143.333 89.0587C144.46 90.4953 145.235 92.1768 145.596 93.9681C145.956 95.7594 145.892 97.6105 145.409 99.3726L127.92 163.209Z"
          fill="#F27376"
        />
        <path
          d="M122.579 95.1689L125.651 74.897L90.936 71.5203L94.168 95.1689H122.579Z"
          fill="#F27376"
        />
        <path
          d="M78.3865 150.472L135.713 147.348L130.694 161.911L82.9593 161.394L78.3865 150.472Z"
          fill="#604EA0"
        />
        <path
          d="M130.694 161.911C130.694 161.911 150.326 180.104 151.495 212.563H63.6708C63.6708 182.057 82.9593 161.395 82.9593 161.395L130.694 161.911Z"
          fill="#604EA0"
        />
        <path
          d="M108.162 165.196L109.308 189.315C109.308 189.315 104.632 187.42 104.724 179.346"
          stroke="#1B1211"
          stroke-width="0.75"
          stroke-miterlimit="10"
        />
        <path
          d="M141.215 175.315H127.003C127.003 175.315 133.639 190.855 147.736 189.488"
          stroke="#1B1211"
          stroke-width="0.75"
          stroke-miterlimit="10"
        />
        <path
          d="M65.7681 191.728C65.7681 191.728 76.2776 194.255 85.5838 179.301"
          stroke="#1B1211"
          stroke-width="0.75"
          stroke-miterlimit="10"
        />
        <path
          d="M94.5229 159.43H84.5864V164.404H94.5229V159.43Z"
          fill="#010101"
        />
        <path
          d="M128.207 159.43H118.27V164.404H128.207V159.43Z"
          fill="#010101"
        />
        <path
          d="M114.236 159.43H99.142V164.404H114.236V159.43Z"
          fill="#010101"
        />
        <path
          d="M110.397 158.431H102.981V165.414H110.397V158.431Z"
          fill="white"
        />
        <path
          d="M20.7387 117.336C23.6661 115.503 27.1999 114.91 30.5633 115.688C33.9267 116.465 36.8443 118.55 38.6748 121.482L64.5763 168.182L56.6454 177.371L16.6128 135.288C14.7901 132.357 14.2009 128.823 14.9743 125.458C15.7477 122.093 17.8206 119.172 20.7387 117.336Z"
          fill="#E88C7B"
        />
        <path
          d="M61.3443 165.334C71.8309 165.334 81.3205 159.993 81.3205 159.993L87.2113 178.45C69.9514 185.009 61.2182 180.69 56.611 177.417L61.3443 165.334Z"
          fill="#E88C7B"
        />
        <path
          d="M81.3201 159.993C81.3201 159.993 90.9815 159.132 97.8924 163.703L99.1416 175.188C99.1416 175.188 91.1191 172.547 85.9044 174.304C85.9044 174.304 94.8209 176.004 98.2821 179.76L95.8409 182.24C90.7648 180.155 85.2514 179.366 79.7958 179.943L81.3201 159.993Z"
          fill="#E88C7B"
        />
        <path
          d="M98.1338 166.643C98.1338 166.643 90.1112 164.025 84.0255 163.852"
          stroke="#1B1211"
          stroke-width="0.75"
          stroke-miterlimit="10"
        />
        <path
          d="M98.6951 171.146C94.0765 169.416 89.1577 168.635 84.2316 168.849"
          stroke="#1B1211"
          stroke-width="0.75"
          stroke-miterlimit="10"
        />
        <path
          d="M48.1414 83.3962L61.6422 97.9254L69.5387 118.393L55.7628 102.726L48.1414 83.3962Z"
          fill="#B45458"
        />
        <path
          d="M67.6935 76.5623L44.4052 90.632L60.7826 117.6L76.0599 107.148L67.6935 76.5623Z"
          fill="#F27376"
        />
        <path
          d="M48.1411 83.3962L55.7626 102.726L69.5384 118.393L57.9745 122.677L47.1669 107.872L39.6257 88.9782L48.1411 83.3962Z"
          fill="white"
        />
        <path
          d="M41.9064 127.317L38.6744 121.482"
          stroke="#1B1211"
          stroke-width="0.75"
          stroke-miterlimit="10"
        />
        <path
          d="M124.963 97.3398C124.055 97.321 123.153 97.4865 122.31 97.8261C121.467 98.1658 120.701 98.6727 120.059 99.3164C119.417 99.9601 118.911 100.727 118.572 101.572C118.233 102.416 118.068 103.321 118.087 104.231C118.127 106.561 119.065 108.786 120.702 110.44C122.34 112.094 124.553 113.051 126.877 113.109C131.737 113.109 134.602 108.837 133.456 104.231C132.963 102.314 131.866 100.607 130.328 99.3657C128.789 98.124 126.891 97.4134 124.917 97.3398M128.55 99.7173C128.654 99.7173 128.734 99.7173 128.814 99.8322C129.266 100.17 129.624 100.616 129.857 101.13C129.972 101.337 129.96 101.463 129.777 101.543C129.593 101.624 129.536 101.762 129.41 101.739C129.284 101.716 129.25 101.498 129.169 101.371C128.828 100.872 128.401 100.436 127.909 100.085L127.783 99.993C128.023 99.8896 128.31 99.8436 128.562 99.7518M121.319 105.219C121.202 105.446 121.132 105.694 121.114 105.949C121.097 106.204 121.131 106.46 121.216 106.701L120.402 106.402C120.363 106.396 120.328 106.377 120.303 106.347C120.278 106.318 120.264 106.28 120.264 106.241C120.178 105.779 120.222 105.302 120.39 104.863C120.39 104.759 120.471 104.725 120.585 104.771L121.273 105.058C121.353 105.058 121.365 105.138 121.273 105.219M131.588 106.609C131.596 106.731 131.566 106.853 131.502 106.958C131.439 107.062 131.344 107.145 131.232 107.194C131.098 107.275 130.942 107.315 130.785 107.309C130.652 107.31 130.521 107.275 130.407 107.206C130.296 107.139 130.208 107.039 130.157 106.919C130.105 106.8 130.093 106.667 130.121 106.54C129.847 106.164 129.518 105.831 129.146 105.552C129.245 106.118 129.245 106.697 129.146 107.263C129.049 107.718 128.875 108.154 128.631 108.55C128.421 108.893 128.144 109.189 127.817 109.423C127.537 109.631 127.228 109.797 126.9 109.916C126.451 110.083 125.98 110.184 125.502 110.215C125.075 110.241 124.646 110.182 124.241 110.043C123.841 109.899 123.483 109.658 123.198 109.342C122.865 108.986 122.611 108.563 122.453 108.102C122.218 107.588 122.119 107.022 122.167 106.459C122.204 105.996 122.358 105.549 122.614 105.161C122.868 104.786 123.191 104.463 123.565 104.208C123.975 103.941 124.418 103.728 124.883 103.576C125.5 103.37 126.146 103.265 126.797 103.266C126.466 102.574 125.89 102.03 125.181 101.739C124.313 101.482 123.39 101.482 122.522 101.739C122.334 101.785 122.137 101.785 121.949 101.739C121.848 101.723 121.753 101.678 121.678 101.608C121.602 101.539 121.549 101.448 121.525 101.348C121.49 101.277 121.473 101.198 121.473 101.119C121.473 101.039 121.49 100.96 121.525 100.889C121.676 100.72 121.877 100.603 122.098 100.556C122.838 100.316 123.613 100.2 124.39 100.211C125.006 100.229 125.612 100.378 126.167 100.648C126.708 100.923 127.182 101.315 127.553 101.796C127.991 102.349 128.343 102.964 128.596 103.622C129.135 103.843 129.634 104.149 130.075 104.53C130.502 104.886 130.886 105.291 131.221 105.736C131.428 105.987 131.566 106.288 131.622 106.609M126.43 104.668C126.112 104.683 125.797 104.733 125.49 104.817C125.218 104.911 124.957 105.035 124.711 105.184C124.492 105.328 124.302 105.511 124.15 105.724C124.01 105.931 123.92 106.166 123.886 106.413C123.854 106.686 123.89 106.962 123.989 107.217C124.139 107.669 124.454 108.047 124.872 108.274C125.077 108.366 125.3 108.413 125.525 108.413C125.75 108.413 125.973 108.366 126.178 108.274C126.447 108.179 126.696 108.035 126.912 107.849C127.139 107.637 127.319 107.379 127.439 107.091C127.573 106.755 127.64 106.396 127.634 106.034C127.638 105.582 127.568 105.132 127.427 104.702C127.101 104.625 126.765 104.598 126.43 104.622M125.513 107.24C125.371 107.236 125.234 107.18 125.129 107.083C125.024 106.986 124.957 106.854 124.94 106.712C124.931 106.647 124.935 106.581 124.953 106.518C124.97 106.455 125.002 106.396 125.044 106.346C125.086 106.296 125.139 106.255 125.198 106.227C125.257 106.199 125.322 106.185 125.387 106.184C125.53 106.188 125.667 106.244 125.772 106.341C125.877 106.438 125.944 106.57 125.96 106.712C125.972 106.777 125.97 106.844 125.952 106.908C125.935 106.972 125.904 107.032 125.862 107.082C125.819 107.133 125.765 107.173 125.705 107.2C125.645 107.228 125.58 107.241 125.513 107.24Z"
          fill="white"
        />
        <path
          d="M182.006 14.0037C200.595 14.0039 215.664 29.1559 215.664 47.8464C215.664 66.5368 200.595 81.688 182.006 81.6882C173.812 81.6882 166.303 78.7436 160.466 73.8503L149.763 76.9216C147.845 77.4717 146.403 75.1703 147.725 73.6687L153.969 66.574C150.418 61.2109 148.348 54.7722 148.348 47.8464C148.348 29.1557 163.417 14.0037 182.006 14.0037Z"
          fill="#EFECEC"
        />
        <g mask="url(#mask0_2437_10563)">
          <path
            d="M180.523 48.3422L177.928 45.7784C177.6 45.4486 177.19 45.2837 176.698 45.2837C176.206 45.2837 175.781 45.4636 175.423 45.8234C175.095 46.1532 174.931 46.573 174.931 47.0828C174.931 47.5925 175.095 48.0123 175.423 48.3422L179.27 52.2102C179.628 52.57 180.046 52.7499 180.523 52.7499C181 52.7499 181.417 52.57 181.775 52.2102L189.38 44.564C189.738 44.2042 189.909 43.7844 189.894 43.3047C189.879 42.8249 189.708 42.4051 189.38 42.0453C189.022 41.6855 188.597 41.4981 188.105 41.4831C187.613 41.4681 187.188 41.6405 186.83 42.0003L180.523 48.3422ZM175.513 64.624L172.918 60.2162L167.998 59.1367C167.55 59.0468 167.192 58.8144 166.924 58.4396C166.656 58.0648 166.551 57.6525 166.611 57.2027L167.103 52.1203L163.748 48.2522C163.45 47.9224 163.301 47.5326 163.301 47.0828C163.301 46.633 163.45 46.2432 163.748 45.9134L167.103 42.0453L166.611 36.9629C166.551 36.5131 166.656 36.1008 166.924 35.726C167.192 35.3512 167.55 35.1188 167.998 35.0288L172.918 33.9494L175.513 29.5416C175.751 29.1518 176.079 28.8894 176.497 28.7545C176.914 28.6195 177.332 28.642 177.749 28.8219L182.402 30.8009L187.054 28.8219C187.471 28.642 187.889 28.6195 188.306 28.7545C188.724 28.8894 189.052 29.1518 189.29 29.5416L191.885 33.9494L196.805 35.0288C197.253 35.1188 197.611 35.3512 197.879 35.726C198.147 36.1008 198.252 36.5131 198.192 36.9629L197.7 42.0453L201.055 45.9134C201.353 46.2432 201.502 46.633 201.502 47.0828C201.502 47.5326 201.353 47.9224 201.055 48.2522L197.7 52.1203L198.192 57.2027C198.252 57.6525 198.147 58.0648 197.879 58.4396C197.611 58.8144 197.253 59.0468 196.805 59.1367L191.885 60.2162L189.29 64.624C189.052 65.0138 188.724 65.2762 188.306 65.4111C187.889 65.546 187.471 65.5235 187.054 65.3436L182.402 63.3646L177.749 65.3436C177.332 65.5235 176.914 65.546 176.497 65.4111C176.079 65.2762 175.751 65.0138 175.513 64.624ZM177.839 61.3856L182.402 59.4066L187.054 61.3856L189.559 57.0678L194.479 55.8984L194.032 50.8609L197.342 47.0828L194.032 43.2147L194.479 38.1772L189.559 37.0978L186.964 32.78L182.402 34.759L177.749 32.78L175.244 37.0978L170.324 38.1772L170.771 43.2147L167.461 47.0828L170.771 50.8609L170.324 55.9883L175.244 57.0678L177.839 61.3856Z"
            fill="#E5637F"
          />
        </g>
      </g>
      <defs>
        <radialGradient
          id="paint0_radial_2437_10563"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(115.5 208.97) rotate(-89.8647) scale(95.4078 115.5)"
        >
          <stop stop-color="#A48AFF" stop-opacity="0.75" />
          <stop offset="1" stop-color="#A48AFF" stop-opacity="0" />
        </radialGradient>
        <linearGradient
          id="paint1_linear_2437_10563"
          x1="2.36372e-06"
          y1="180"
          x2="231"
          y2="180"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#604EA0" stop-opacity="0" />
          <stop offset="0.5" stop-color="#604EA0" />
          <stop offset="1" stop-color="#604EA0" stop-opacity="0" />
        </linearGradient>
        <clipPath id="clip0_2437_10563">
          <rect
            width="200.97"
            height="180"
            fill="white"
            transform="translate(14.63)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export default Approval;
